module.exports = __webpack_public_path__ + "img/why-keyapl-1.e9d3a12b.png";